import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { Tag } from 'antd';

import './BadgeBar.css';

@withRouter
@inject('translationsStore', 'carsStore', 'filterStore')
@observer
export default class Toolbar extends Component {
  componentDidMount = () => {
    const { filterStore } = this.props;
    filterStore.addToMonitoring(`summary.withHelpRequests`);
    filterStore.addToMonitoring(`summary.withAlarmsAndSafety`);
    filterStore.addToMonitoring(`summary.withLowBattery`);
    filterStore.addToMonitoring(`summary.withDtcsRedPlusOrange`);
    filterStore.addToMonitoring(`summary.withMaintenances`);
  };

  componentWillUnmount = () => {
    const { filterStore } = this.props;
    filterStore.removeFromMonitoring(`summary.withHelpRequests`);
    filterStore.removeFromMonitoring(`summary.withAlarmsAndSafety`);
    filterStore.removeFromMonitoring(`summary.withLowBattery`);
    filterStore.removeFromMonitoring(`summary.withDtcsRedPlusOrange`);
    filterStore.removeFromMonitoring(`summary.withMaintenances`);
  };

  render() {
    const { translationsStore, carsStore } = this.props;

    return (
      <div className="BadgeBar" style={{ ...this.props.style, display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
        {carsStore.virtualCarsCount > 0 && (
          <Fragment>
            <Tag className="helpRequests" style={{ cursor: 'default' }}>{`${carsStore.virtualBadges.withHelpRequests} ${translationsStore.translate(
              'lead.summary.action'
            )}`}</Tag>
            <Tag className="alarms" style={{ cursor: 'default' }}>{`${carsStore.virtualBadges.withAlarmsAndSafety} ${translationsStore.translate('lead.summary.alarms')}`}</Tag>
            <Tag className="lowBattery" style={{ cursor: 'default' }}>{`${carsStore.virtualBadges.withLowBattery} ${translationsStore.translate(
              'lead.summary.lowBattery'
            )}`}</Tag>
             <Tag className="dtcsRed" style={{ cursor: 'default' }}>{`${carsStore.virtualBadges.withDtcsRedPlusOrange} ${translationsStore.translate(
              'lead.summary.dtcs'
            )}`}</Tag>
            <Tag className="maintenance" style={{ cursor: 'default' }}>{`${carsStore.virtualBadges.withMaintenances} ${translationsStore.translate(
              'lead.summary.maintenance'
            )}`}</Tag>
          </Fragment>
        )}
      </div>
    );
  }
}
